import React from 'react';
import { domToReact, HTMLReactParserOptions, htmlToDOM } from 'html-react-parser';

import './styles.scss';
import Icon from '../Icon';

export interface IRenderHTMLProps {
    /** HTML string to render */
    html: string;
    /** className to use */
    className?: string;
    /** Do not wrap */
    nowrapper?: boolean;
    /** Replace config */
    config?: HTMLReactParserOptions['replace'];
}



/**
 * Renders HTML string to DOM tree. Also looks for known React components.
 */

const RenderHTML: React.FC<IRenderHTMLProps> = (props) => {

    const code = props.html.replace(/(\r\n\t|\n|\r\t)/gm, '').trim();

    const parserOptions = {
        replace: (domNode: any) => {
            if (domNode.name) {
                // Icon
                if (domNode.name === 'icon') {
                    return (
                        <Icon
                            width={parseInt(domNode.attribs.width, 10)}
                            height={parseInt(domNode.attribs.height, 10)}
                            kind={domNode.attribs.kind}
                        />
                    );
                }


            }

            if (props.config) {
                return props.config(domNode, 0);
            }

            return false;
        },
    };

    if (props.nowrapper) {
        return (
            <React.Fragment>
                {domToReact(htmlToDOM(code.replace(/>\s+</g, '><')), parserOptions)}
            </React.Fragment>
        );
    } else {
        return (
            <div className={props.className || 'longtext'}>
                {domToReact(htmlToDOM(code.replace(/>\s+</g, '><')), parserOptions)}
            </div>
        );
    }
}

export default RenderHTML;

RenderHTML.displayName = "RenderHTML"